import TOP_BARS from '@topBars';

/**
 * 课次签到：详情 / 出码 / 扫码结果（Teacher + Admin 共用入口）
 * 静态段 code / result 须排在 /checkin/:id 之前
 */
export default [
  {
    path: '/checkin/code/:id',
    name: 'checkin-code',
    meta: {
      title: '签到二维码',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/CheckIn/Code')
  },
  {
    path: '/checkin/result/:id',
    name: 'checkin-result',
    meta: {
      title: '签到',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/CheckIn/Result')
  },
  {
    path: '/checkin/:id',
    name: 'checkin-detail',
    meta: {
      title: '签到页'
    },
    component: () => import('@/views/CheckIn/Detail')
  }
];
